import { InsuranceProviders } from '../../enums/insurance-providers';
import { useInsuranceUrl } from './use-insurance-url';

export const useGetFileAClaimDetails = (sellerId, insuranceBookingId, insuranceClaimInitiationUrl, insuranceProviderName) => {
  const showFileAClaim = InsuranceProviders[insuranceProviderName]?.canFileAClaim ?? false;
  const isParcelGuard = insuranceProviderName === InsuranceProviders.ParcelGuard.name;
  const isXCover = insuranceProviderName === InsuranceProviders.XCover.name;
  const isShipsurance = insuranceProviderName === InsuranceProviders.Shipsurance.name;
  const url = useInsuranceUrl(sellerId, insuranceBookingId, insuranceClaimInitiationUrl, insuranceProviderName);

  return {
    showFileAClaim,
    isParcelGuard,
    isXCover,
    isShipsurance,
    url,
  };
};
